export default {"src":"/_next/static/media/separator.f9ab97d9.svg","height":19,"width":2,"blurWidth":0,"blurHeight":0};